import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import Typography from '@mui/material/Typography';
import React from 'react';
import accounting from 'accounting-js';
import { alpha } from '@mui/material/styles';

export const returnNumberColumn = (
  headerName,
  field,
  width = 120,
  formattingPrecision = 0,
  symbol = (params: GridRenderCellParams) => params?.row?.currencySymbol || '',
) => ({
  field,
  type: 'number',
  headerName,
  width,
  valueGetter: (params) => {
    return (
      (params?.value === 'string' ? parseInt(params.value) : params?.value) || 0
    );
  },
  renderCell: (params: GridRenderCellParams) => (
    <Typography noWrap>
      {accounting.formatMoney(params.value, {
        precision: formattingPrecision,
        symbol: symbol(params),
      })}
    </Typography>
  ),
});

export const getTableStyle = (theme) => ({
  root: {
    '& .pos': {
      background: alpha(
        theme.palette.success.main,
        theme.palette.action.activatedOpacity,
      ),
    },
    '& .neg': {
      background: alpha(
        theme.palette.error.main,
        theme.palette.action.activatedOpacity,
      ),
    },
    '& .amber': {
      background: alpha(
        theme.palette.warning.main,
        theme.palette.action.activatedOpacity,
      ),
    },
  },
});
